import cookie from 'react-cookies'

export const TOKEN_KEY = 'token'

export const POSTER_KEY = 'poster_key'

export const MOBILE_KEY = 'mobile'

export const getCookie = (key: string): string | number => cookie.load(key)

export const setCookie = (key: string, value: string | number): void => {
  cookie.save(key, value, { path: '/' })
}

export const deleteCookie = (key: string): void => cookie.remove(key)

export const getToken = () => {
  return JSON.parse(localStorage.getItem(TOKEN_KEY) || '{}')?.token
}

export const getUserInfo = () => {
  return JSON.parse(localStorage.getItem(TOKEN_KEY) || '{}')?.account_info
}

export const getStorage = (key) => {
  return JSON.parse(localStorage.getItem(key) || '{}')
}
